const trackFormFilling = () => {
  setTimeout(() => {
    VK.Retargeting.Event('PageView30sec');
  }, 30000);

  const forms = document.querySelectorAll("form");
  if (!forms.length) return;

  forms.forEach((form) => {
    const formInputs = form.querySelectorAll("input");
    let isFilling = false;

    const onFieldEvent = () => {
      if (!isFilling) {
        ym(105136647, "reachGoal", "FormStart");
        VK.Retargeting.Event("Initiate_Checkout");
        _tmr.push({ type: 'reachGoal', id: 3721015, goal: 'initiate_checkout'});
        isFilling = !isFilling;
      }
    };

    formInputs.forEach((input) =>
      input.addEventListener("input", onFieldEvent)
    );
  });
};

export default trackFormFilling;
